<template>
  <z-page class="user-list">
    <!-- appid -->
    <div class="appid">
      <span>APPID：</span>
      <span v-if="CRMstatus==0" @click="()=>CRMflag=true" class="font-btn normal">立即配置</span>
      <span v-else-if="CRMstatus=='1'" class="edit">尚未初始化</span>
      <span v-else-if="CRMstatus=='3'" class="edit">配置完成</span>
      <span v-if="CRMstatus=='2'" class="font-btn normal">初始化中</span>
      <span v-if="CRMstatus=='2'" class="CRMtip">（预计需要2~3天时间，初始化完成后即可正常使用）</span>
      <span v-if="CRMstatus==0" class="CRMtip">（需先进行 APPID 配置才可正常使用CRM功能）</span>
      <span
        class="font-btn normal"
        @click="()=>CRMflag=true"
        v-if="CRMstatus=='1'||CRMstatus=='3'"
      >修改</span>

      <!-- 提示开通窗口 -->
    </div>
    <z-windowPop
      v-model="CRMflag"
      width="518px"
      :black="true"
      :btnshow="true"
      savetext="确定"
      @confirm="$func.shake(CRM_congfig)"
      top="30%"
      :title="CRMstatus==0?'配置 APPID':'修改 APPID'"
    >
      <div class="CRM-pop-main">
        <div class="CRM-pop-tip">配置 APPID 后预计需要2~3天时间进行初始化</div>
        <div class="CRM-item">
          <label>APPID：</label>
          <el-input v-model="nowCRM.appid" size="mini" placeholder="请输入"></el-input>
        </div>
        <div class="CRM-item">
          <label>APPKEY：</label>
          <el-input v-model="nowCRM.appkey" size="mini" placeholder="请输入"></el-input>
        </div>
        <div class="CRM-more font-btn normal" @click="CRMtipOpen">
          如何获取 APPID、APPKEY？
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
    </z-windowPop>

    <z-windowPop
      v-model="CRMtip"
      width="530px"
      height="800px"
      :black="true"
      top="50vh"
      title="提示"
      :cancelbtnshow="false"
    >
      <div class="CRM-pop-main" style="height:700px">
        <div v-if="CRMtip" class="CRM-tip-main">
          <div class="CRM-tip-title">
            1、
            <span @click="turntoCRM()" class="font-btn normal">进入CRM</span>，点击界面右上角
            <font>系统设置</font> 。
          </div>
          <div class="CRM-tip-img">
             <img src="@/assets/img/inCRM.png" alt="">
          </div>
          <div class="CRM-tip-title">
            2、点击左侧导航栏中的
            <font>版本信息</font>。
          </div>
          <div class="CRM-tip-img">
             <img src="@/assets/img/left.png" alt="">
          </div>
          <div class="CRM-tip-title">
            3、复制
            <font>Open API 服务接口</font> 下的
            <font>APPID</font> 与
            <font>APPKEY</font> （需先点击完整显示）即可。
          </div>
          <div class="CRM-tip-img">
             <img src="@/assets/img/app.png" alt="">
          </div>
        </div>
      </div>
    </z-windowPop>

    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item">
        <div>姓名：</div>
        <div>
          <el-input size="mini" v-model="value" placeholder="关键字搜索" suffix-icon="el-icon-search"></el-input>
        </div>
      </div>
      <div @click="searchData" class="search-btn z-btn normal">搜索</div>
      <div @click="clearData" style="margin-left:10px" class="search-btn">清除搜索</div>
      <div @click="manageropen()" style="height:28px" class="z-btn normal floatright">添加客户经理</div>
      <div @click="branchshow=true" style="height:28px" class="z-btn normal floatright">分配规则</div>
      <div @click="turnto()" style="height:28px" class="z-btn normal floatright">开通管理</div>

      <div @click="turntoCRM()" style="height:28px" class="z-btn normal floatright">进入CRM</div>
    </div>

    <!-- 列表 -->
    <div class="page-list">
      <div class="list-head">
        <div class="tipdiv">关联账号

          <el-tooltip class="item" effect="light" content="关联已有账号，在产品线财务管理中将会以关联账号合并统计" placement="top-start">
            <div slot="content">关联已有账号，在产品线财务管<br/>理中将会以关联账号合并统计</div>
            <img class="Notes" src="~@/assets/img/help.svg">
          </el-tooltip>

        </div>
        <div>姓名</div>
        <div>QQ</div>
        <div>联系电话</div>
        <div>绑定账号</div>
        <div>CRM到期时间</div>
        <div>续费状态</div>
        <div>操作</div>
      </div>
      <div v-loading="loading" class="list-main">
        <div style="text-align:center" class="list-item" v-if="data.list.length<=0">暂无数据</div>
        <div class="list-item" v-for="(item,index) in data.list" :key="index">
          <div
            :title="item.unionSaleAccount"
            :style="{'border':sort_arr[index]?'#CDD1D4 1px solid':'none','height':sort_arr[index]?40*sort_arr[index]+'px':'0px','line-height':sort_arr[index]?39*sort_arr[index]+'px':'0px'}"
          >{{ item.unionSaleAccount||'--' }}</div>
          <div>{{ item.saleName||'--' }}</div>
          <div :class="{'nodata':!item.qq}">{{ item.qq ||'--' }}</div>
          <div :class="{'nodata':!item.mobile}">{{ item.mobile||'--' }}</div>
          <div
            :title="item.account ||'--'"
            :class="{'nodata':!item.account}"
          >{{item.account ||'--'}}</div>
          <div>
            <span >{{ item.crmExpireTime||'未开通' }}</span>
          </div>
          <div>
            <span> {{item.crmExpireTime?(item.crmStatus=='1'?'开':'关'):'--'}}   </span>
          </div>
          <div>
            <span style="padding:5px;" class="font-btn normal" @click="openRelation(item)">关联账号</span>
            <span style="padding:5px;" class="font-btn danger" @click="opendel(item)">删除</span>
          </div>
        </div>
      </div>
      <z-pagination
        @sizeChange="getData()"
        @pageChange="handleCurrentChange"
        :current-page.sync="now_page"
        :page-size="10"
        :total="total"
      ></z-pagination>
    </div>
    <!-- 关联账号 -->
    <z-windowPop
      v-model="relationFlag"
      width="518px"
      :black="true"
      :btnshow="true"
      savetext="确定"
      @confirm="$func.shake(relation_func)"
      top="30%"
      title="关联账号"
    >
      <div style="height:100px" class="CRM-pop-main">
        <div class="CRM-item">
          <label>关联账号：</label>
          <el-input v-model="nowRelation.unionSaleAccount" size="mini" placeholder="请输入"></el-input>
        </div>
      </div>
    </z-windowPop>

    <!-- 客户经理分配规则 -->
    <z-windowPop
      v-model="branchshow"
      width="454px"
      height="500px"
      :black="true"
      :btnshow="true"
      @confirm="$func.shake(addbranch)"
      top="50%"
      title="客户经理分配规则"
    >
      <div class="popmain">
        <div class="search-item">
          <div class="title">产品名称：</div>

          <el-select
            class="content"
            size="mini"
            v-model="branchkey"
            slot="prepend"
            placeholder="请选择"
          >
            <el-option
              v-for="(item,index) in product"
              :key="index"
              :label="item.category_name"
              :value="item.ecsProduct.kfProductKey"
            ></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <div class="title">指定轮询：</div>
          <div style="height:300px;overflow:auto">
            <div
              class="card unactiveitem"
              @click="item.pollingStatus=!item.pollingStatus"
              :class="{'activeitem':item.pollingStatus}"
              v-for="(item, index) in branchlist"
              :key="index"
            >
              <el-radio-group v-model="item.pollingStatus">
                <el-radio class="radio" :label="true">&nbsp;</el-radio>
              </el-radio-group>
              <!-- <el-radio v-model="item.pollingStatus"  class="radio"></el-radio> -->
              <div class="name">{{item.saleName}}</div>
              <div class="account">{{item.account}}</div>
            </div>
            <img class="nodata" v-if="branchlist.length==0" src="@/assets/img/nodata.svg" alt />
          </div>
        </div>
      </div>
    </z-windowPop>
    <!-- 添加客户经理 -->
    <z-windowPop
      v-model="addshow"
      width="454px"
      :btnClass="canNext"
      :savetext="addindex==3?'完成':'下一步'"
      :black="true"
      :btnshow="true"
      @confirm="$func.shake(addmanager)"
      top="50%"
      title="添加客户经理"
    >
      <div >
        <div>
          <div class="head">
            <div class="frist">
              <div
                class="icon"
                :class="{'ok':this.addindex!=1,'now':this.addindex==1}"
              >{{this.addindex==1?'1':'√'}}</div>
              <div class="title">选择员工</div>
            </div>
            <div class="line" :class="{'ok':this.addindex==3}"></div>
            <div class="frist">
              <div class="icon" :class="{'now':this.addindex==3}">2</div>
              <div class="title">配置CRM</div>
            </div>
          </div>
          <div v-show="addindex==1" class="popbody">
            <div style="overflow:auto" v-for="(item, grounpindex) in addlist" :key="grounpindex">
              <div class="title">{{item.groupName}}：</div>
              <div
                @click="addmanagerlist(val)"
                class="card unactiveitem"
                :class="{'activeitem':val.has}"
                v-for="(val, BUindex) in item.groupList"
                :key="BUindex"
              >
                <el-radio-group v-model="val.has">
                  <el-radio class="radio" :label="true">&nbsp;</el-radio>
                </el-radio-group>
                <div class="name">{{val.name}}</div>
                <div class="account">{{val.workerId}}</div>
              </div>
              <div class="nodata" v-if="item.groupList.length==0">暂无数据</div>
            </div>
          </div>
          <div v-show="addindex==3" class="popbody">
            <div style="margin-top:100px;margin-left:28px;height:200px;" class="popitem">
              <div style="display:inline-block;">开通所选员工CRM：</div>
              <div style="display:inline-block;" class="popinput">
                <el-switch disabled v-model="addCRM"></el-switch>
                <span
                  style="margin-left:15px;font-size:12px;color:rgba(16,30,56,0.4);line-height:20px;"
                >已开通CRM的员工不受影响</span>
              </div>
            </div>
          </div>
        </div>
        <div class="return" @click="addindex=1" v-if="addindex!=1">上一步</div>
      </div>
    </z-windowPop>

    <!-- 删除提示窗口 -->
    <z-windowPop
      v-model="delshow"
      width="454px"
      :black="true"
      :btnshow="true"
      savetext="删除"
      btnClass="danger"
      @confirm="$func.shake(delmanager)"
      top="50%"
      title="提示信息"
    >
      <div class="delmain">
        <img src="../../assets/img/warn_icon.svg" alt />
        <span>是否删除客户经理{{delname}}</span>
      </div>
    </z-windowPop>
    <!-- 提示开通窗口 -->
    <z-windowPop
      v-model="openshow"
      width="454px"
      :black="true"
      :btnshow="btn_show"
      savetext="开通"
      @confirm="$func.shake(crmOpening)"
      top="50%"
      title="提示信息"
    >
      <div class="delmain">
        <img src="../../assets/img/warn_icon.svg" alt />
        <span>是否开通CRM，资费30元/月,{{time}}秒后可开通。</span>
      </div>
    </z-windowPop>
  </z-page>
</template>

<script>
export default {
  data() {
    return {
      addindex: 1,
      branchkey: "",
      product: {},
      branchshow: false,
      branchlist: [],
      addlist: [],
      addCRM: true,
      openshow: false,
      btn_show: false,
      time: 5,
      delshow: false, //是否删除弹窗
      delid: "",
      delname: "", //删除弹窗中的名字
      loading: true, //是否加载重
      value: "",
      search: {
        text: "" //搜索内容
      },
      timer: "",
      addshow: false, //是否添加/编辑弹窗
      data: {
        list: []
      },
      now_list: {}, //需要操作的内容的容器
      now_page: 1, // now 页
      total: 1, //总数
      CRMstatus: 0, //CRM 配置状态  0 未配置
      CRMflag: false, //配置CRM的flag
      nowCRM: {
        appid: "",
        appkey: ""
      }, //配置CRM 的容器
      CRMtip: false, //是否显示CRM 提示
      relationFlag: false, //关联账号 flag
      nowRelation: "", //关联账号容器
      sort_arr: [] //排序所用的数组
    };
  },
  computed: {
    //是否进行下一步
    canNext() {
      if (this.addindex == 1) {
        let num = 0;
        this.addlist.map(val => {
          val.groupList.map(x => {
            if (x.has) {
              num++;
            }
          });
        });
        if (num == 0) {
          return "disablenext";
        } else {
          return "normal";
        }
      }
      return "normal";
    },
    // 根据字符串返回
    switch_list() {
      return function(value) {
        if (value == "1") {
          return true;
        }
        return false;
      };
    }
  },
  watch: {
    branchkey(val) {
      this.getbranchlist();
    }
  },
  created() {
    this.$store.dispatch("getproduct").then(res => {
      this.branchkey = res[0].ecsProduct.kfProductKey;
      this.product = res;
    });
    this.getData();
    this.getstafflist();
    this.getCRMstatus();
  },
  methods: {
    //关联方法
    relation_func() {
      console.log(this.nowRelation);

      let url = `/api/supplier/sales/union`;
      this.$http
        .post(url, {
          saleAccount: this.nowRelation.account,
          saleId6d: this.nowRelation.id6d,
          unionSaleAccount: this.nowRelation.unionSaleAccount
        })
        .then(res => {
          console.log(res);
          if (res.code == "200") {
            this.relationFlag = false;
            this.successTip(res.res_data);
            this.getData();
          } else {
            this.errorTip(res.res_data);
          }
        });
    },
    //打开管理账号
    openRelation(val) {
      this.relationFlag = true;
      this.nowRelation = JSON.parse(JSON.stringify(val));
    },
    //点击确定配置
    CRM_congfig() {
      if (this.CRMstatus == "1" || this.CRMstatus == "3") {
        let url = `/api/supplier/crm/app/edit`;
        this.$http
          .post(url, {
            appId: this.nowCRM.appid,
            appSecret: this.nowCRM.appkey
          })
          .then(res => {
            this.CRMflag = false;
            if (res.code == "200") {
              this.successTip("修改成功！");
              this.getCRMstatus();
            } else {
              this.errorTip(res.res_data);
            }
          });
      } else {
        let url = `/api/supplier/crm/app/add`;
        this.$http
          .post(url, {
            appId: this.nowCRM.appid,
            appSecret: this.nowCRM.appkey
          })
          .then(res => {
            this.CRMflag = false;
            if (res.code == "200") {
              this.successTip(res.res_data);
              this.getCRMstatus();
            } else {
              this.errorTip(res.res_data);
            }
          });
      }
    },
    //点击提示语
    CRMtipOpen() {
      this.CRMtip = true;
    },
    //获取当前CRM状态
    getCRMstatus() {
      let url = `/api/supplier/curr/crm/app/get`;
      this.$http.get(url).then(res => {
        console.log(res);
        if (res.code == "200" && res.res_data) {
          this.CRMstatus = res.res_data.initStatus;
          this.nowCRM.appid = JSON.parse(JSON.stringify(res.res_data.appId));
          this.nowCRM.appkey = JSON.parse(
            JSON.stringify(res.res_data.appSecret)
          );
        } else {
          this.CRMstatus = 0;
        }
      });
    },
    //将员工加入到 list
    addmanagerlist(val) {
      if (val.has) {
        val.has = !val.has;
      } else {
        val.has = true;
      }
    },
    //客户经理分配规则
    addbranch() {
      let url = "/api/supplier/sales/assign/rule";
      let ids_yes = [];
      let ids_no = [];
      this.branchlist.map(val => {
        if (val.pollingStatus) {
          ids_yes.push(val.id);
        } else {
          ids_no.push(val.id);
        }
      });
      ids_yes = ids_yes.join(",");
      ids_no = ids_no.join(",");
      this.$http
        .post(url, "", {
          params: {
            ids_no: ids_no,
            ids_yes: ids_yes || "",
            product_key: this.branchkey
          }
        })
        .then(res => {
          console.log(res);
          if (res.code == "200") {
            this.getbranchlist();
            this.successTip(res.res_data);
            this.branchshow = false;
          } else {
            this.errorTip(res.res_data);
          }
        });
    },
    getbranchlist() {
      let url = `/api/supplier/sale/assign/get/sales`;
      this.$http
        .get(url, {
          params: {
            product_key: this.branchkey
          }
        })
        .then(res => {
          if (res.code == "200") {
            this.branchlist = res.res_data;
            this.branchlist.map(val => {
              val.pollingStatus = val.pollingStatus == "1" ? true : false;
            });
          }
        });
    },
    // 页数改变时
    handleCurrentChange(val) {
      this.now_page = val;
      this.getData();
    },
    // 清除搜索条件并搜索
    clearData() {
      this.search.text = "";
      this.value = null;
      this.handleCurrentChange(1);
    },
    //搜索条件 并搜索
    searchData() {
      this.search.text = this.value;
      this.handleCurrentChange(1);
    },
    // 进入CRM 方法
    turntoCRM() {
      this.$func.getsasstoken().then(res => {
        let tempPage = window.open("", " _blank");
        this.url =
          `http://www.365.wisecrm.com/user/53kf-login?&token=` +
          res.data.server_response.once_token;
        tempPage.location = this.url;
      });
    },
    // 跳转到开图服务的地方
    turnto() {
      this.$func.getsasstoken().then(res => {
        let tempPage = window.open("", " _blank");
        this.url =
          `${this.$url.kuaifu}/?controller=usercenter&token=` +
          res.data.server_response.once_token;
        tempPage.location = this.url;
      });
    },
    //获取数据
    getData(num) {
      this.now_page=num||this.now_page
      this.loading = true;
      let url = `/api/supplier/get/sales/list`;
      this.$http
        .get(url, {
          params: {
            page: num || this.now_page,
            name: this.search.text || null
          }
        })
        .then(res => {
          if (res.code == 200) {
            this.data = res.res_data;
            this.total = res.res_data.total;
            let arr = [];
            // this.data.list.map((val,i) => {
            //   val.istrue = false;
            // });
            for (let i = 0; i < this.data.list.length; ) {
              var count = 0;
              for (var j = i; j < this.data.list.length; j++) {
                if (
                  this.data.list[i].unionSaleAccount ==
                  this.data.list[j].unionSaleAccount
                ) {
                  count++;
                }
              }
              arr[i] = count;
              i += count;
            }
            console.log(arr);
            this.sort_arr = arr;
          } else {
            this.errorTip(res.res_data);
          }
          this.loading = false;
        })
        .catch(err => {
          console.log(err);

          // this.errorTip("请求失败");
          this.loading = false;
        });
    },
    //打开 添加/修改  并判断  弹窗
    manageropen(item) {
      // if (item) {
      //   this.now_list = JSON.parse(JSON.stringify(item));
      // } else {
      //   this.now_list = {};
      // }
      this.addlist=[]
      this.getstafflist();

      this.addindex = 1;
      this.addshow = true;
    },
    getstafflist() {
      let url = "/api/supplier/sales/add/get/employee";
      this.$http.get(url).then(res => {
        if (res.code == "200") {
          res.res_data.employee_data.map(val => {
            val.groupList.map(x => {
              this.$set(x, "has", false);
            });
          });
          this.addlist = res.res_data.employee_data;
        }
      });
    },
    //打开删除提示
    opendel(val) {
      this.delshow = true;
      this.delname = val.account;
      this.delid = val.id;
    },
    //删除
    delmanager() {
      let delurl = `/api/supplier/sale/delete`;
      this.$http
        .post(
          delurl,
          {},
          {
            params: {
              id: this.delid
            }
          }
        )
        .then(res => {
          if (res.code == "200") {
            this.successTip("删除成功!");
          } else {
            this.errorTip(res.res_data);
          }
          this.getData();
        })
        .catch(err => {
          this.getData();
        });
      this.delshow = false;
    },
    //开通CRM 提示
    crmshow(val) {
      this.now_list = val;
      this.openshow = true;
      this.btn_show = false;
      clearInterval(this.timer);
      this.time = 5;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          this.btn_show = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    crmOpening() {
      this.openshow = false;
      let openurl = `/api/supplier/sale/crm/open`;
      this.$http
        .post(openurl, "", {
          params: {
            id: this.now_list.id
          }
        })
        .then(res => {
          if (res.code == "200") {
            this.successTip("开通成功!");
            this.getData();
          } else {
            this.errorTip("开通失败!");
          }
        })
        .catch(err => {
          this.errorTip("开通失败！");
          this.getData();
        });
    },
    //修改或者添加接口
    addmanager(val) {
      if (val && val == "edit") {
      }
      //编辑
      if (this.addindex == 3) {
        //保存
        let id6ds = [];
        this.addlist.map(val => {
          val.groupList.map(x => {
            if (x.has) {
              id6ds.push(x.id6d);
            }
          });
        });

        let url = "/api/supplier/sales/add";
        this.$http
          .post(
            url,
            {},
            {
              params: {
                id6ds: id6ds.join(","),
                is_crm_open: this.addCRM ? "1" : "2"
              }
            }
          )
          .then(res => {
            if (res.code == "200") {
              this.getstafflist();
              this.getData();
            }
          });
        this.addshow = false;
      } else {
        this.addindex = 3;
      }
      // if (this.now_list["id6d"]) {
      // let editurl = `/api/supplier/sale/edit`;
      // this.$http
      //   .post(editurl, "", {
      //     params: {
      //       id: this.now_list.id,
      //       name: this.now_list.saleName,
      //       qq: this.now_list.qq,
      //       mobile: this.now_list.mobile,
      //       rate: this.now_list.rate
      //     }
      //   })
      //   .then(res => {
      //     if (res.code == "200") {
      //       this.successTip("保存成功!");
      //       this.getData();
      //     } else {
      //       this.errorTip("保存失败!");
      //     }
      //   });
      //   // 添加
      // } else {
      //   let addurl = `/api/supplier/sale/add`;
      //   this.$http
      //     .post(
      //       addurl,
      //       {},
      //       {
      //         params: {
      //           account: this.now_list.account,
      //           name: this.now_list.saleName,
      //           qq: this.now_list.qq,
      //           mobile: this.now_list.mobile,
      //           rate: this.now_list.rate
      //         }
      //       }
      //     )
      //     .then(res => {
      //       if (res.code == "200") {
      //         this.successTip("添加成功!");
      //         this.getData();
      //       } else {
      //         this.errorTip("添加失败" + res.res_data);
      //         this.errorTip(res.res_data);
      //       }
      //     });
      // }
    }
  }
};
</script>

<style lang="less" scoped>
.appid {
  padding: 16px 0 0 16px;
  line-height: 22px;
  .edit {
    font-weight: 400;
    color: rgba(109, 114, 120, 1);

    line-height: 22px;
    & + .font-btn {
      margin-left: 8px;
    }
  }
  .CRMtip {
    color: rgba(230, 162, 61, 1);
  }
}
.open-hight {
  height: 506px !important;
}
.CRM-pop-main {
  height: 192px;
  .CRM-tip-main {
    padding: 28px 24px 24px 24px;
    .CRM-tip-title {
      font-size: 14px;
      font-weight: 400;
      color: rgba(16, 30, 56, 1);
      line-height: 30px;
    }
  }
  .CRM-pop-tip {
    padding-left: 16px;
    height: 40px;
    background: rgba(253, 246, 236, 1);
    font-size: 14px;
    font-weight: 400;
    color: rgba(230, 162, 61, 1);
    line-height: 40px;
  }
  .CRM-more {
    float: right;
    padding-right: 36px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 161, 255, 1);
    line-height: 20px;
  }
  .CRM-item {
    padding: 24px 24px 0 24px;
    & + .CRM-item {
      padding-top: 16px;
      padding-bottom: 12px;
    }
    label {
      display: inline-block;
      width: 70px;
      text-align: right;
    }
    /deep/ .el-input {
      width: calc(~"100% - 70px");
    }
  }
}
.popmain {
  padding: 12px 24px 0px;
  .popitem {
    padding: 8px 0px;
    .poptitle {
      display: inline-block;
      text-align: right;
      width: 20%;
    }
    .popinput {
      display: inline-block;
      width: 80%;
    }
  }
  .search-item {
    position: relative;
    &:nth-child(1) {
      padding-bottom: 10px;
    }
    width: 100%;
    .title {
      display: inline-block;
      width: 20%;
    }
    .content {
      width: 80%;
    }

    .nodata {
      position: absolute;
      width: 80px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .card {
      margin-bottom: 10px;
    }
  }
}
.list-head {
  border: none;
  border-top: #cdd1d4 1px solid;
  border-bottom: #cdd1d4 1px solid;
}
.list-head,
.list-item {
  .tipdiv {
    overflow: visible;
    position: relative;
    .Notes {
      display: inline-block;
      width: 14px;
      box-sizing: border-box;
      vertical-align: middle;
      &:hover {
        cursor: pointer;
        & + .tip {
          opacity: 1;
        }
      }
    }
    .tip {
      pointer-events: none;
      position: absolute;
      background: rgba(0, 0, 0, 0.7);
      opacity: 0;
      z-index: 30;
      transition: 0.3s;
      top: 5px;
      left:0;
      color: #fff;
      white-space: nowrap;
      padding: 0 8px;
      line-height: 28px;
      border-radius: 4px;
    }
  }
  border-bottom: none;
  > div {
    border-bottom: #cdd1d4 1px solid;
    width: 12%;
    &:nth-child(2n-1) {
      border-left: #cdd1d4 1px solid;
      border-right: #cdd1d4 1px solid;
    }
    &:nth-child(1) {
      border-top: none !important;
      width: 12%;
    }
    &:nth-child(6) {
      width: 16%;
    }
    &:nth-child(8) {
      width: 15%;
    }
    &:nth-child(7) {
      width: 9%;
    }
    &:nth-child(5) {
      width: 12%;
    }
    &:nth-child(6),
    &:nth-child(7),
    &:nth-child(8) {
      text-align: center;
    }
  }
}
.head {
  .frist {
    &:nth-child(1) {
      padding-left: 16px;
    }
    display: inline-block;
    padding-left: 8px;
    .icon {
      width: 24px;
      height: 24px;
      border-radius: 24px;
      border: 1px solid rgba(205, 209, 212, 1);
      color: rgba(205, 209, 212, 1);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      &.ok {
        color: rgba(22, 163, 255, 1);
        border: rgba(22, 163, 255, 1) solid 1px;
      }
      &.now {
        background: rgba(22, 163, 255, 1);
        color: #fff;
        border: rgba(22, 163, 255, 1) solid 1px;
      }
    }
    .title {
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      color: rgb(23, 28, 37);
      line-height: 20px;
      padding-left: 8px;
    }
  }
  .line {
    display: inline-block;
    margin-left: 8px;
    margin-bottom: 4px;
    width: 49px;
    height: 1px;
    background: rgba(205, 209, 212, 1);
    &.ok {
      background: rgba(22, 163, 255, 1);
    }
  }
}
.popbody {
  overflow: auto;
  .card {
    margin-left: 20px;
    margin-bottom: 10px;
  }
  height: 350px;
  .title {
    padding-left: 20px;
    line-height: 32px;
  }
  .nodata {
    height: 50px;
    line-height: 50px;
    text-align: center;
    margin: 10px 20px;
    // background: red;
    border: 1px solid rgba(205, 209, 212, 1);
  }
}
.return {
  cursor: pointer;
  position: absolute;
  bottom: 4.4%;
  left: 5%;
  width: 74px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(205, 209, 212, 1);
  &:hover {
    background: @g_Sbtn_h;
  }
  &:active {
    background: @g_Sbtn_a;
  }
}

.activeitem {
  border: 1px solid rgba(22, 163, 255, 1) !important;
  color: #101e38 !important;
}
.unactiveitem {
  border: 1px solid rgba(205, 209, 212, 1);
  color: rgba(16, 30, 56, 0.4);
}

</style>
